import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// zh-TW resources
import zhTWCommon from './locales/zh-TW/common.json';
import zhTWSettings from './locales/zh-TW/settings.json';
import zhTWHome from './locales/zh-TW/home.json';
import zhTWHomepage from './locales/zh-TW/homepage.json';
import zhTWAuth from './locales/zh-TW/auth.json';
import zhTWMain from './locales/zh-TW/main.json';

// en resources
import enCommon from './locales/en/common.json';
import enSettings from './locales/en/settings.json';
import enHome from './locales/en/home.json';
import enHomepage from './locales/en/homepage.json';
import enAuth from './locales/en/auth.json';
import enMain from './locales/en/main.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en', label: 'English' },
];

export const DEFAULT_LANGUAGE = 'zh-TW';
export const FALLBACK_LANGUAGE = 'zh-TW';

const resources = {
  'zh-TW': {
    common: zhTWCommon,
    settings: zhTWSettings,
    home: zhTWHome,
    homepage: zhTWHomepage,
    auth: zhTWAuth,
    main: zhTWMain,
  },
  en: {
    common: enCommon,
    settings: enSettings,
    home: enHome,
    homepage: enHomepage,
    auth: enAuth,
    main: enMain,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS: 'common',
    ns: ['common', 'settings', 'home', 'homepage', 'auth', 'main'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nLanguage',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
